import { queryOptions, useMutation } from "@tanstack/react-query";
import profileService from "../services/profile-service";

export const useRemoveAvatarMutation = (options?: { enabled: boolean }) => {
	return useMutation({
		mutationKey: ["profile"],
		mutationFn: profileService.removeAvatar,
		meta: {
			successMessage: "Avatar removed successfully",
		},
		...options,
	});
};

export const profileSessionQueryOptions = () => {
	return queryOptions({
		queryKey: ["profile_sessions"],
		queryFn: () => profileService.getSessions(),
	});
};
